import { render } from "./Declined.vue?vue&type=template&id=12d6d915&scoped=true"
import script from "./Declined.vue?vue&type=script&lang=js"
export * from "./Declined.vue?vue&type=script&lang=js"

import "./Declined.vue?vue&type=style&index=0&id=12d6d915&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12d6d915"]])

export default __exports__